import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from "react-redux";
import { store } from "./Redux/store";

import App from "./App";
import { CanvasProvider } from "./Components/core/workspace/CanvasProvider";
import ScrollToTop from "./Components/ScrollTop";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
// store.subscribe(() => console.log("store", store.getState()));
root.render(
  <BrowserRouter>
    <ChakraProvider>
      <Provider store={store}>
        <CanvasProvider>
          <ScrollToTop />
          <App />
        </CanvasProvider>
      </Provider>
    </ChakraProvider>
  </BrowserRouter>,
);
